export class LanguagePage {
  idLanguagePage: number;
  name: string;
  orphan: boolean;

  constructor(
    idLanguagePage: number,
    name: string,
    orphan: boolean,
  ) {
    this.idLanguagePage = idLanguagePage;
    this.name = name;
    this.orphan = orphan;
  }

  static fromRaw(raw: any): LanguagePage {
    return new LanguagePage(
      Number(raw.idLanguagePage),
      String(raw.name),
      Boolean(raw.orphan),
    );
  }

  clone(): LanguagePage {
    return new LanguagePage(
      this.idLanguagePage,
      this.name,
      this.orphan,
    );
  }

  toPayload(): any {
    return {
      idLanguagePage: this.idLanguagePage,
      name: this.name,
      orphan: this.orphan,
    };
  }
}
